















































import { Component, Mixins } from 'vue-property-decorator';

import { View } from 'client-website-ts-library/plugins';

@Component
export default class RequestMaintenance extends Mixins(View) {
  mounted() {
    let scr: HTMLScriptElement | null = document.getElementById('tapi-embed-js') as HTMLScriptElement | null;
    if (scr) scr.remove();

    setTimeout(() => {
      scr = document.createElement('script');
      scr.src = '//tapi.app/js/embed.js';
      scr.async = true;
      scr.defer = true;
      scr.id = 'tapi-embed-js';

      scr.onload = () => {
        console.log('Integration Loaded');
      };

      document.head.append(scr);
    }, 500);
  }
}
